export function getInitBiomass(subTab) {
  let newValue = null;
  if (subTab === 'White Pine Needle Damage') {
    newValue = 7;
  } else if (subTab === 'Beech Leaf Disease') {
    newValue = 1;
  } else if (subTab === 'White Oak Freeze Damage' || subTab === 'Red Oak Freeze Damage') {
    newValue = 4;
  } else {
    newValue = 0;
  }
  return newValue;
}